module.exports = __webpack_public_path__ + "img/asu_sunburst_rgb_maroongold_150ppi.65f83105.png";